<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Video Course` : "Add Video Course" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-autocomplete
          v-model="form.course_id"
          :items="courses"
          item-text="name"
          item-value="id"
          label="Course*"
          :append-icon="course_id ? '' : 'mdi-menu-down'"
          :readonly="course_id ? true : false"
          outlined
          dense
          :rules="[rules.required]"
        ></v-autocomplete>
        <v-text-field
          v-model.trim="form.week_no"
          label="Week Number*"
          outlined
          dense
          maxlength="2"
          :rules="[rules.required, rules.number]"
        />
        <v-text-field
          v-model.trim="form.url"
          label="URL*"
          outlined
          dense
          :rules="[rules.required, rules.url]"
        />
        <v-textarea
          v-model.trim="form.description"
          label="Description*"
          outlined
          dense
          row="3"
          hide-details="auto"
          :rules="[rules.required]"
        />
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    video_course: {
      type: Object,
      default: () => {},
    },
    courses: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    course_id: {
      type: Number,
      default: () => null,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
    };
  },
  computed: {},
  created() {
    this.init();
    if (this.course_id) {
      this.form.course_id = this.course_id;
    }
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.video_course };
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        this.$emit(this.edit ? "update" : "create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
